const RUNNER_NAME = 'ChameleonRunner';
const APP_NAME = 'ChameleonApp';

const validateRunner = runner => typeof runner.sendMessage === 'function';

const handleRunnerOptions = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('options')) {
    return false;
  }

  const options = JSON.parse(urlParams.get('options'));
  options.os = urlParams.get('os');

  return options;
};

class Runner {
  constructor() {
    this.detected = false;
    this.valid = false;
    this.options = null;
    this.outbound = {};
    this.inbound = {};
    window[APP_NAME] = this.inbound;
    this.detect();
  }

  detect() {
    if (window.location.search) {
      const options = handleRunnerOptions();

      if (options) {
        this.detected = true;
        this.valid = true;
        this.options = options;

        return;
      }
    }

    // eslint-disable-next-line
    if (!window.hasOwnProperty(RUNNER_NAME)) {
      console.error('ChameleonRunner not detected.');
      return;
    }

    this.outbound = window[RUNNER_NAME];
    this.detected = true;

    if (!validateRunner(this.outbound)) {
      console.error('ChameleonRunner detected, but missing sendMessage method.', this.outbound);
      return;
    }

    console.info('ChameleonRunner detected.', this.outbound);
    this.valid = true;
  }

  sendMessage(message) {
    if (!this.detected) {
      console.error('ChameleonRunner not detected.', message);
      return;
    }

    if (!this.valid) {
      console.error('ChameleonRunner doesn\'t have sendMessage method', message);
      return;
    }

    this.outbound.sendMessage(JSON.stringify(message));
  }

  setListener(handlerFn) {
    this.inbound.sendMessage = handlerFn;
  }

  isValid() {
    return this.valid;
  }

  // isDetected() {
  //   return this.detected;
  // }
}

export default Runner;
